<template>
  <div :class="[`protokol-ekosistem-2`, className || ``]">
    <div class="protokol-ekosistem">
      <div class="overlap-group-12">
        <div class="reach-goals-that-mat inter-medium-chetwode-blue-12px">protokol ekosistem</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ProtokolEkosistem",
  props: ["className"],
};
</script>

<style>
.protokol-ekosistem-2 {
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: 10px;
  justify-content: center;
  position: relative;
  margin: 0 auto
}

.protokol-ekosistem {
  border: 0px none;
  border-radius: 15px;
  height: 31px;
  margin-bottom: -1px;
  margin-left: -1px;
  margin-right: -1px;
  margin-top: -1px;
  min-width: 179px;
  position: relative;
}

.overlap-group-12 {
  align-items: flex-start;
  background-image: url(/otplanding/rectangle-4@2x.png);
  background-size: 100% 100%;
  display: flex;
  height: 35px;
  left: -3px;
  min-width: 183px;
  padding: 5.9px 30.6px;
  position: relative;
  top: -2px;
}

.reach-goals-that-mat {
  letter-spacing: 0;
  line-height: 22px;
  min-height: 21px;
  text-align: center;
  white-space: nowrap;
  width: 122px;
}

.protokol-ekosistem-2.protokol-ekosistem-4 {
  left: 100px;
  top: 4164px;
}

.protokol-ekosistem-2.protokol-ekosistem-5 {
  left: 77px;
  top: 67px;
}
</style>
